var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var EXPERIMENTS_HEADER = 'x-experiments';
export var FEATURES_HEADER = 'x-features';
export var getEnrolmentsFromHeader = function (experimentsHeader) {
    if (!experimentsHeader)
        return [];
    var enrolments = experimentsHeader.split(',');
    return enrolments.reduce(function (acc, curr) {
        var _a = curr.split('='), experimentId = _a[0], experimentState = _a[1];
        if (!experimentId || !experimentState)
            return acc;
        return __spreadArray(__spreadArray([], acc, true), [
            {
                experiment: experimentId,
                group: experimentState,
            },
        ], false);
    }, []);
};
export var getEnrolmentsFromRequest = function (req) {
    var experimentsHeader = req.headers[EXPERIMENTS_HEADER];
    if (!experimentsHeader) {
        return [];
    }
    if (typeof experimentsHeader === 'object') {
        return getEnrolmentsFromHeader(experimentsHeader.join(','));
    }
    return getEnrolmentsFromHeader(experimentsHeader);
};
export var getFeaturesFromRequest = function (req) {
    var featuresHeader = req.headers[FEATURES_HEADER];
    if (!featuresHeader) {
        return [];
    }
    if (typeof featuresHeader === 'object') {
        return featuresHeader.join(',').split(',');
    }
    return featuresHeader.split(',');
};
export var serializeExperiments = function (experiments) {
    if (Array.isArray(experiments) && experiments.length > 0) {
        return experiments
            .filter(function (experiment) { return experiment && experiment.experiment && experiment.group; })
            .map(function (experiment) { return "".concat(experiment.experiment, "=").concat(experiment.group); })
            .sort()
            .join(',');
    }
    return '';
};
